import React from "react";
import { SVG } from "../../assets/SVG/SVG";
import Carousel from "../../component/Carousel/Carousel";
import * as slides from "../../component/Carousel/CarousalSlides";

const RegistrationSuccess: React.FC = () => {
  return (
    <div>
      <div className=" flex justify-center items-center max-h-screen">
        <div className="lg:p-12 md:p-52 sm:20 p-8 w-full lg:w-1/2">
          <SVG.LogoDark />
          <div className="my-8">
            <SVG.Success />
          </div>

          <h6 className="text-xs text-gray-400 mb-4">
            Link to Create password is sent into your registered email!
          </h6>
        </div>
        <div className="w-1/2 h-screen hidden lg:block">
          <div className="onboard-box">
            <Carousel slides={slides.slides} />
          </div>
        </div>
      </div>
    </div>
  );
};
export default RegistrationSuccess;
